import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e009844a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "database" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "banner_cont" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "section" }
const _hoisted_6 = { class: "menu_cont" }
const _hoisted_7 = { class: "menu_wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "name" }

import { useRouter } from 'vue-router';
import { TMenuType } from '@/module/database';
import { useStore } from 'vuex';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const store = useStore()



onMounted(() => {

})



const onToRouterList = (row: TMenuType) => {
    console.log(row);
    router.push({ path: 'databaseList', query: { Id: row.Id } })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(store).state.bannerUrl,
          alt: ""
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.secondLevelMenu, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "menu_item",
              key: index,
              onClick: ($event: any) => (onToRouterList(item))
            }, [
              _createElementVNode("div", {
                class: "imageText",
                style: _normalizeStyle({backgroundImage:`url('${item.PicUrl}')`})
              }, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, _toDisplayString(item.Name), 1)
              ], 4),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.Name), 1)
              ])
            ], 8, _hoisted_8))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})